import { Grid, Paper, Typography } from "@mui/material";

const FootprintSummaryDisplay = ({ value, unit, color, label, action }) => (
  <Paper elevation={0} style={{ padding: "24px", borderRadius: "12px" }}>
    <Grid
      container
      justifyContent="space-between"
      alignItems="flex-start"
      wrap="nowrap"
    >
      <Grid item>
        <Typography variant="overline" color="textSecondary">
          {label}
        </Typography>
        <Typography variant="h2" color={color}>
          {value}
        </Typography>
        {unit && (
          <Typography variant="body2" color="textSecondary">
            {unit}
          </Typography>
        )}
      </Grid>
      {action && <Grid item>{action}</Grid>}
    </Grid>
  </Paper>
);
export default FootprintSummaryDisplay;
